import { auth } from '@/firebaseConfig';

export default class AuthHelper {
  async getAuthHeaders () {
    if (!auth.currentUser) { return {}; }
    let token = await auth.currentUser.getIdToken();
    return {Authorization: `Bearer ${token}`};
  }
}